export default __webpack_public_path__ + "static/media/place-1.7ea57797.jpg";